import styled from '@mui/material/styles/styled';

const StyledTextArea = styled('textarea', {
  shouldForwardProp: (prop) => !['noGutters'].includes(prop),
})(({ theme, noGutters }) => ({
  width: '100%',
  border: '1px solid',
  // boxShadow: 'inset 0px 2px 6px -3px rgba(0, 0, 0, 0.48)',
  backgroundColor: '#33CCCC1A',
  borderRadius: 8,
  marginBottom: noGutters ? 0 : 18,
  fontSize: '1rem',
  color: theme.palette.text.primary,
  padding: 12,
  borderColor: `transparent`,
  outline: 'none',
  resize: 'none',
  '&:focus': {
    outline: 'none',
    // borderColor: theme.palette.primary.main,
  },
}));

export default StyledTextArea;
